<template>
    <div class="page-loader">
        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle ref="circle" class="circle" fill="transparent" stroke-width="2" cx="33" cy="33" r="30" stroke="var(--white-color)"></circle>
        </svg>
        <p class="text mt-5">{{loadingText}}</p>
    </div>
</template>

<script>
    import { bus } from '../../main'

    export default {
        name: "page-loader",
        data() {
            return {
                loadingText: ""
            }
        },
        created() {
            bus.$on("page-load-text", text => {
                this.loadingText = text;
            });
        },
        mounted() {
            setTimeout(() => {
                if (this.$refs.circle) {
                    // let circleLenght = this.$refs.circle.getTotalLength ? this.$refs.circle.getTotalLength() : 188;
                    let circleLenght = 188;
                    this.$refs.circle.style.strokeDasharray = circleLenght;
                    let i = 0;
                    setInterval(() => {
                        i++
                        if (this.$refs.circle)
                            this.$refs.circle.style.strokeDashoffset = i + "px"
                    }, 1000 / 120)
                }
            },100)
        },
        beforeDestroy() {
            this.loadingText = ""
        }
    }
</script>

<style scoped>
    .page-loader {
        position: fixed;
        flex-direction: column;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(100, 100, 100, .4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
    }
    .page-loader .circle {
        stroke-dashoffset: 1px;
        animation: rotate .80s linear infinite;
        transform-origin: center;
    }
    .page-loader .text {
        color: var(--white-color);
        text-align: center;
    }
    @keyframes rotate {
        100%{
            transform: rotate(360deg);
        }
    }
</style>
